import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'policy-de',
    templateUrl: './policy-de.component.html',
    styleUrls: ['./policy-de.component.scss']
})
export class PolicyDeComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
